import React from 'react';
import { Card } from "react-bootstrap";
import face_oliver_hortay from "../../assets/img/face_oliver_hortay.jpg";
import ShowMoreText from "react-show-more-text";
import proj_EU_energy_crisis from "../../assets/img/proj_EU_energy_crisis.png";

const Oliver_Hortay_EU_energy = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_EU_energy_crisis} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_oliver_hortay}
              /* this will be the text on the banner */
              alt="Economic and Social Impact of the European Energy Crisis"
            />{" "}
            <p className="text7">Olivér Hortay</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Deparment of Finance, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In recent years, the European energy markets have undergone unprecedented changes. 
            The prices on regional electricity, gas, and carbon quota exchanges have exhibited 
            volatility never seen before. This turbulent period has significantly altered corporate 
            concentration—some energy companies have gone bankrupt, while others have achieved 
            record profits. The driving forces behind demand and supply have transformed, forecasting 
            and risk management methods had to be adjusted, and the public's attitude towards the 
            energy sector has fundamentally shifted. Within the framework of the task, participants 
            are free to choose a specific issue from the intersection of energy-society-economy 
            (such as demand or price forecasting, geopolitical impact assessment, price elasticity 
            studies, etc.), in which they can achieve new results using a quantitative method.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Oliver_Hortay_EU_energy;